var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"minimap"},[_c('div',{staticClass:"minimap__content",class:_vm.contentClass},[(_vm.backgroundImageUrl)?_c('AppImage',{staticClass:"minimap__content__image",attrs:{"src":_vm.backgroundImageUrl}}):_vm._e()],1),_c('div',{staticClass:"minimap__lens",class:_vm.lensClass,style:(_vm.lensStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }